module.exports = __webpack_public_path__ + "img/nanbu.31ec1638.jpg";